export default "__VITE_ASSET__Xv9oQ0ey__"